import API from './api'

export interface EventoResult {
  data?: any
  code?: string
  error?: string
  config?: any
  ok?: boolean
}
export interface Participante {
  nombres: string
  apellidos: string
  dni: string
  email: string
  telefono: string
  institucion: string
  programa: string
}

export interface AsistenciaForm {
  id_evento: number | string
  id_participante?: number | string
  participante?: Participante | any
}

export interface Evento {
  descripcion: string
  url: string
}

export const eventoService = {
  async getEvento(id_evento: number | string): Promise<EventoResult | null> {
    const { data } = await API.getRequest(`/asistencia/evento/${id_evento}`)
    return data as EventoResult
  },
  async Asistencia(form: AsistenciaForm): Promise<EventoResult> {
    const { data } = await API.postRequest('/asistencia', form)
    return data as EventoResult
  },
}

export default eventoService
